import TopicPage from './topic'

export { TopicPage }
